module.exports = __webpack_public_path__ + "files/cc75c6380af232aad1b8af6414f1fd7a.png";